import { RegistryItem } from "@schemas/calculationmethods/schema";
import { CalculationMethodType, PayableOver } from "__generated__/graphql";
import CargoQuantityCalculationMethodForm from "view/calculationmethods/components/form/CargoQuantityCalculationMethodForm";
import CargoQuantityCalculationMethodDetails from "view/calculationmethods/components/details/CargoQuantityCalculationMethodDetails";

export const CargoQuantitySchema: RegistryItem = {
	[CalculationMethodType.CargoQuantity]: {
		Form: CargoQuantityCalculationMethodForm,
		Details: CargoQuantityCalculationMethodDetails,
		fields: {
			"calculationMethod.cargoQuantityUnit": { path: "cargoQuantityUnit", rules: { required: true } },
			"calculationMethod.preAgreed": { path: "preAgreed", rules: { requiredIf: ({ calculationMethod }) => calculationMethod?.payableOver === PayableOver.Preagreed } },
			"calculationMethod.payableOver": { path: "payableOver", rules: { required: true } },
		},
		toInput: (form) => ({
			cargoQuantityCalculationMethodInput: {
				id: form.id,
				cargoQuantityUnit: form.cargoQuantityUnit,
				payableOver: form.payableOver,
				preAgreed: form.preAgreed,
				weightRanges: form.weightRanges?.map(x => ({
					from: x.from,
					to: x.to,
					price: x.price,
				})),
				minimumQuantityPayable: form.minimumQuantityPayable,
				minimumPrice: form.minimumPrice,
				price: form.price,
			},
		}),
		toForm: (method) => ({
			cargoQuantityUnit: method.cargoQuantityUnit ?? undefined,
			weightRanges: method.weightRanges?.map(x => ({
				from: x.from ?? 0,
				to: x.to ?? 0,
				price: x.price ?? 0,
			})),
		}),
	},
};
